import { render, staticRenderFns } from "./propaganda.vue?vue&type=template&id=7f2360da&scoped=true&"
import script from "./propaganda.vue?vue&type=script&lang=js&"
export * from "./propaganda.vue?vue&type=script&lang=js&"
import style0 from "./propaganda.vue?vue&type=style&index=0&id=7f2360da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2360da",
  null
  
)

export default component.exports